<template>
	<div>
		  <a-row>
		  	<a-col :span="10">
				<a-row class="banner-title">
					<a-col :span="20"><h3>公司风采列表</h3></a-col>
					<a-col :span="4"><a-button type="danger" icon="plus-square" @click="showAddStyleModal">发布风采</a-button></a-col>
				</a-row>
				<a-card hoverable style="width: 300px;float: left; margin: 10px;" v-for="item in 2">
					<img
					alt="example"
					src="https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"
					slot="cover"
					/>
					<template class="ant-card-actions" slot="actions">
						<a-icon type="edit"  @click="showCommodityModal"/>
						<a-icon type="ellipsis" />
					</template>
					<a-card-meta title="公司风采" description="这是一条公司风采">
						<a-avatar
						slot="avatar"
						src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
						/>
					</a-card-meta>
				</a-card>
		  	</a-col>
		  	<a-col :span="10" class="preview_phone">
		  	</a-col>
		  	<a-col :span="4">
		  	</a-col>
		  </a-row>
		  
		  <a-modal width="840px" :title="menu" :visible="addCompanyStyleWindow" :confirmLoading="addCompanyStyleLoading" @cancel="addCompanyStyleCancel" footer=''>
		  	<a-form :form="form" @submit="handleSubmit">
		  		<a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" label="个人风采标题">
		  			<a-input v-decorator="['menu', { rules: [{ required: true, message: '请输入个人风采标题' }] }]" placeholder="请输入个人风采标题" />
		  		</a-form-item>
		  		<a-form-item  :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" label="封面">
					<a-upload
						:action="domain"
						:data="QiniuData"
						:beforeUpload="beforeUpload"
						listType="picture-card"
						:fileList="bannerList"
						:remove="bannerRemove"
					>
						<div v-if="bannerList.length < 1">
							<a-icon type="plus" />
							<div class="ant-upload-text">封面</div>
						</div>
					</a-upload>
		  		</a-form-item>
				<a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 15 }" label="个人风采简介">
					<a-textarea 
						v-decorator="['intro', { rules: [{ required: true, message: '请输入个人风采简介' }] }]"
						placeholder="请输入个人风采简介" :rows="7" />
				</a-form-item>
				<a-form-item :wrapper-col="{ span: 12, offset: 5 }">
				  <a-button type="primary" html-type="submit">
					保存
				  </a-button>
				</a-form-item>
		  	</a-form>
		  </a-modal>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		data() {
			return {
				menu: '风采',
				addCompanyStyleWindow: false,
				addCompanyStyleLoading: false,
				form: this.$form.createForm(this, { name: 'dynamic_rule' }),
				imageUrl: '',
				QiniuData: {
					key: "", //图片名字处理
					token: "" //七牛云token
				},
				domain: "https://upload-z2.qiniup.com", // 七牛云的上传地址（华南区）
				qiniuaddr: "http://cdn.diqwl.com", // 七牛云的图片外链地址
				pictureAddress: '',
				bannerList: [
					{
						uid: '1',
						name: 'xxx.png',
						status: 'done',
						url: 'http://cdn.diqwl.com/1568038714890.png'
					}
				],
			};
		},
		mounted() {
			this.getQiniuToken()
		},
		methods: {
			bannerRemove(file){
				var index = this.bannerList.findIndex(item =>{
				if(item.uid==file.uid){
					return true
				}
			})
				console.log(index)
				this.bannerList.splice(index,1)
			},
			showAddStyleModal(){
				this.addCompanyStyleWindow = true;
			},
			showCommodityModal(item) {
				this.addCompanyStyleWindow = true;
			},
			addCommodityOk() {
				console.log(this.form.getFieldsValue());
				this.form.validateFields(err => {
					if (!err) {
						console.info('success');
					} else {
						return;
					}
				});
				this.ModalText = 'The modal will be closed after two seconds';
				this.addMenuLoading = true;
				setTimeout(() => {
					this.addCompanyStyleWindow = false;
					this.addCompanyStyleLoading = false;
				}, 1000);
			},
			addCompanyStyleCancel() {
				this.addCompanyStyleWindow = false;
			},
			commodityMoney(value) {
				console.log(value);
			},
			handleChange(info) {
				if (info.file.status === 'uploading') {
					this.loading = true;
					return;
				}
				if (info.file.status === 'done') {
					// Get this url from response in real world.
					getBase64(info.file.originFileObj, imageUrl => {
						this.imageUrl = imageUrl;
						this.loading = false;
					});
				}
			},
			beforeUpload(file) {
				const isPNG = file.type === "image/png";
				const isJPEG = file.type === "image/jpeg";
				const isJPG = file.type === "image/jpg";
				const isLt2M = file.size / 1024 / 1024 < 2;
						
				if (!isPNG && !isJPEG && !isJPG) {
				  this.$message.error("上传头像图片只能是 jpg、png、jpeg 格式!");
				  return false;
				}
				if (!isLt2M) {
				  this.$message.error("上传头像图片大小不能超过 2MB!");
				  return false;
				}
				this.QiniuData.key = `store_banner_${file.name}`;
				this.pictureAddress = this.qiniuaddr +"/"+ this.QiniuData.key;
				
				var obj = {
					status: 'done'
				};
				obj.uid = file.uid;
				obj.name = this.QiniuData.key;
				obj.url = this.pictureAddress;
				this.bannerList.push(obj)
			},
			handlePreview(file) {
				this.previewImage = file.url || file.thumbUrl;
				this.previewVisible = true;
			},
			//请求后台拿七牛云token
			getQiniuToken() {
				axios({
					method: "post",
					url: "/api/file/v1/qiniu/getToken",
					data: JSON.stringify({
						"param": "1",
						"appType": "IOS",
						"appVersion": "1",
						"uuid": "18",
						"system": "IOS",
						"brand": "Apple",
						"model": "IPHONE 7 Plus",
						"systemVersion": "12",
						"apiVersion": "1",
						"platform": "1",
						"nonce": "181"
					}),
					headers: {
						"authCode":'GJaImrLgzbgKQ0GaNX5kgCDtPrk7mcdF6Kq2zxe62pU=',
					  'Content-Type': 'application/json',
					  'token': '9032858a-f133-4c7c-aa5d-27331dea3f0d',
					  "device": 'admin'
					}
				}).then(res => {
					if (res.data.status == 200) {
						this.QiniuData.token = res.data.data.token;
					} else {
					  console.log("炸了")
					}
				});
			},
			handleSubmit (e) {
			  e.preventDefault()
			  this.form.validateFields((err, values) => {
			    if (!err) {
			      console.log('Received values of form: ', values)
			    }
			  })
			},
		}
	};
</script>

<style>
	.banner-title {
		border-bottom: 2px solid gray;
		margin-bottom: 30px;
		margin-top: 10px;
	}
	.preview_phone {
		width: 670px;
		height: 670px;
		background-image: url('../../static/phone.png');
		background-size: 100%;
	}
</style>
